import React from 'react';
import { Button, Col } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ArrowButton from '../button-arrow';
import './datatable.css'

const IgniteDataTable = ({
  data, 
  columns, 
  actions, 
  actionWidth = undefined, 
  inlineActions=true, 
  hideId = true, 
  hasAttributes = true, 
  pagination = false, 
  remote = false, 
  dataSize,
  cellEdit = {},
}) => {
  const renderNested = (cell, row, attr) => {
    // early return if render() function is passed and it evaluates to false
    if (typeof attr.render === 'function' && !attr.render(cell, row)) {
      return null;
    }

    let data = hasAttributes ? _.get(cell, attr.prop) : _.get(row, attr.prop);

    if (typeof attr.format === 'function') {
      data = attr.format(data, row);
    }

    // if onClick() function is passed, we are rendering a link

    if (typeof attr.onClick === 'function' && data != null) {
      return (
        <Button bsStyle="link" onClick={() => attr.onClick(data, row)}>
          {data}
        </Button>
      );
    }

    return data;
  };

  if (actions) {
    const renderActions = (cell, row) => {
      const actionsCount = inlineActions ? actions.length : 1;

      return (
        <div className="actions-column row">
          {
            actions.map((item, index) => {
              // early return if render() function is passed and it evaluates to false
              if (typeof item.render === 'function' && !item.render(cell, row)) {
                return <Col lg={12 / actionsCount} key={index}/>;
              }

              return (
                <Col lg={12 / actionsCount} key={index}>
                  <ArrowButton permissions={item.permissions}
                               arrow={false}
                               submit={false}
                               block={!inlineActions}
                               color={item.color || 'red'}
                               className={item.className}
                               disabled={typeof item.disabled === 'function' ? item.disabled(row) : false}
                               onClick={typeof item.callback === 'function' ? () => item.callback(row) : undefined}>
                      {item.label}</ArrowButton>
                </Col>
              )
            })
          }
        </div>
      )
    };

    var renderedActions = <TableHeaderColumn dataField='actions'
                                             hidden={!actions || !actions.length}
                                             className="ignite-table-header"
                                             width={actionWidth}
                                             dataFormat={renderActions}>Actions</TableHeaderColumn>
  }

  const paginationOptions = Object.assign({}, {
    sizePerPageList: [
      { text: '10', value: 10 },
      { text: '20', value: 20 },
      { text: 'All', value: data.length }
    ],
    sizePerPage: 10,
    prePage: '«',
    nextPage: '»',
    alwaysShowAllBtns: true,
    hideSizePerPage: true
  }, pagination);

  return (
    <BootstrapTable data={data}
                    tableContainerClass="ignite-table"
                    trClassName="ignite-table-row"
                    pagination={!!pagination}
                    remote={remote}
                    fetchInfo={{ dataTotalSize: dataSize ? dataSize : data.size}}
                    options={paginationOptions}
                    cellEdit={cellEdit}>
      <TableHeaderColumn isKey
                         hidden={hideId}
                         dataField='id'
                         className="ignite-table-header"
                         width="50">ID</TableHeaderColumn>
      {
        columns.map((column, index) => {
          return <TableHeaderColumn key={index}
                                    dataField={hasAttributes ? 'attributes' : column.prop}
                                    dataFormat={renderNested}
                                    width={column.width}
                                    className="ignite-table-header"
                                    columnClassName="ignite-table-data"
                                    formatExtraData={{
                                      prop: column.prop,
                                      onClick: column.onClick,
                                      render: column.render,
                                      format: column.format
                                    }}
                                    editable={column.editable || false}>{column.title}</TableHeaderColumn>
        })
      }
      {renderedActions}
    </BootstrapTable>
  )
};

IgniteDataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    prop: PropTypes.string.isRequired,
    title: PropTypes.string,
    onClick: PropTypes.func,
    render: PropTypes.func
  })).isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      'red','yellow','grey','white'
    ]),
    className: PropTypes.any,
    permissions: PropTypes.shape({
      action: PropTypes.string,
      subjectClass: PropTypes.string,
      mode: PropTypes.oneOf(['hide', 'disable'])
    }),
    callback: PropTypes.func,
    render: PropTypes.func
  })),
  actionWidth: PropTypes.string,
  inlineActions: PropTypes.bool,
  hideId: PropTypes.bool,
  hasAttributes: PropTypes.bool,
  pagination: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object
  ]),
  remote: PropTypes.bool,
  dataSize: PropTypes.number
};

IgniteDataTable.defaultProps = {
  hideId: true,
  hasAttributes: true,
  pagination: false,
  remote: false,
  inlineActions: true,
};

export default IgniteDataTable;



// WEBPACK FOOTER //
// ./src/components/common/datatable/index.jsx